// extracted by mini-css-extract-plugin
export var dropdownButton = "_4a-0";
export var fullWidthDropdownButton = "_4a-1";
export var icon = "_4a-3";
export var iconPlaceholder = "_4a-2";
export var menuItemRow = "_4a-9";
export var separator = "_4a-e";
export var shortcutContainer = "_4a-7";
export var shortcutContainerFilled = "_4a-8";
export var shortcutIconLg = "_4a-6";
export var shortcutIconMd = "_4a-5";
export var shortcutIconSm = "_4a-4";
export var submenuChevron = "_4a-d";
export var submenuDropdown = "_4a-a";
export var submenuTriggerRow = "_4a-b";
export var submenuTriggerRowOpen = "_4a-c";